import { Base } from "../../framework/common/base";
import {
    OptionWorkTimeDefaultTimeZone,
    OptionWorkTimeDefaultTimeZoneEnabled,
} from "../../models/common/consts";
import { useAppOptionValue } from "./useAppOptionValue";

export const useWorkTimeDefaultTimezone = (): [string | null, boolean] => {
    const [enabled, loading] = useAppOptionValue<boolean>(
        OptionWorkTimeDefaultTimeZoneEnabled
    );
    const [tz] = useAppOptionValue<string>(OptionWorkTimeDefaultTimeZone);
    return [(enabled && tz) || Base.timeZoneName(), loading];
};
